export const QualifyTechnicalFieldsFormConstants = {
  PRODUCT_TAB: "product_tab",
  PACKING_TAB: "packing_tab",
};
